import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-hot-toast";
import { Triangle } from "react-loader-spinner";

import OrderManagementService from "../../../Services/QRCodeServices/Order Management/OrderManagementService";
import TableService from "../../../Services/QRCodeServices/TableSerivce/TableService";
import { DownloadBill } from "../component/DownloadBill";
import { PrintBill } from "../component/PrintBill";
import { BillContent } from "../component/BillContent";
import PaymentModal from "../component/PaymentModal";
import CancelOrderModal from "../CancelOrderComponent/CancelOrderModal";

// import "./OrderMenu.css";

export const OrderMenuMobile = ({
  selectedTable,
  setSelectedTable,
  setTotalOrder,

}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [orgCode, setOrgCode] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tables, setTables] = useState([]);
  const [additionalDiscount, setAdditionalDiscount] = useState("");
  const [apiOrderedItems, setApiOrderedItems] = useState([]);
  const [localOrderedItems, setLocalOrderedItems] = useState([]);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [serviceChargePercentage, setServiceChargePercentage] = useState(0);
  const [taxPercentage, setTaxPercentage] = useState(0);
  const [orderId, setOrderId] = useState(null);
  const [printBillData, setPrintBillData] = useState(null);
  const user = JSON.parse(localStorage.getItem("user"));
  const role = user ? user.user.roles[0] : null;

  const { currentOrder } = useSelector((state) => state.Order);


  useEffect(() => {
    const storedUserInfo = localStorage.getItem("user");
    if (storedUserInfo) {
      const parsedUserInfo = JSON.parse(storedUserInfo);
      setOrgCode(parsedUserInfo?.organizationInfo?.orgCode || null);
    }
    fetchTables();
  }, []);

  if (apiOrderedItems && localOrderedItems) {
    setTotalOrder(apiOrderedItems.length + localOrderedItems.length);
  }

  useEffect(() => {
    if (selectedTable?.id) {
      fetchOrderedItems();
    }
  }, [selectedTable]);

  const fetchTables = async () => {
    try {
      setLoading(true);
      const [tablesData, activeTables] = await Promise.all([
        TableService.getList(),
        TableService.getActiveTableList(),
      ]);

      const tableOptions = tablesData.map((table) => {
        const activeTable = activeTables.find(
          (active) => active.id === table.id
        );
        const storedData = JSON.parse(localStorage.getItem("orders")) || [];
        const hasOrders = storedData.some(
          (order) => order.tableID === table.id && order.items.length > 0
        );
        return {
          value: table.id,
          label: table.identification || `Table ${table.id}`,
          id: table.id,
          // isOccupied: !!activeTable || hasOrders,
          isOccupied: (activeTable && activeTable.isOccupied) || hasOrders,
          menuOrder: activeTable?.menuOrder || null,
        };
      });

      setTables(tableOptions);
    } catch (error) {
      console.error("Error fetching tables:", error);
      toast.error("Failed to fetch tables");
    } finally {
      setLoading(false);
    }
  };

  const fetchOrderedItems = async () => {
    if (!selectedTable?.id) return;

    try {
      setLoading(true);
      const storedData = JSON.parse(localStorage.getItem("orders")) || [];
      const tableOrder = storedData.find(
        (order) => order.tableID === selectedTable.id
      );

      if (tableOrder && tableOrder.items.length > 0) {
        const formattedLocalOrders = tableOrder.items.map((item, index) => ({
          ...item,
          menuOrderDetailId:
            item.menuOrderDetailId || `local_${index}_${item.menuItemId}`,
          source: "Local Storage",
        }));
        setLocalOrderedItems(formattedLocalOrders);
      } else {
        setLocalOrderedItems([]);
      }

      const activeTables = await TableService.getActiveTableList();
      const tableData = activeTables.find(
        (table) => table.id === selectedTable.id
      );

      if (tableData?.menuOrder?.menuOrderDetails) {
        setOrderId(tableData.menuOrder.id); // Set orderId if exists
        const formattedApiOrders = tableData.menuOrder.menuOrderDetails.map(
          (item) => ({
            menuOrderDetailId:
              item.menuOrderDetailId || `api_${item.menuItemId}`,
            menuItemId: item.menuItemDetail?.id || item.menuItemId,
            title: item.menuItemDetail?.title || "Unknown Item",
            price: item.price || item.menuItemDetail?.price || 0,
            quantity: item.quantity || 1,
            totalPrice:
              item.totalPrice ||
              (item.price || item.menuItemDetail?.price || 0) *
                (item.quantity || 1),
            discountDetail: item.menuItemDetail?.discountDetail || {
              discountPercentage: 0,
            },
            cloudR2ImagePath: item.menuItemDetail?.cloudR2ImagePath || null,
            fullUrl: item.menuItemDetail?.fullUrl || null,
            source: "API",
          })
        );
        setApiOrderedItems(formattedApiOrders);
        const { serviceChargePercentage, taxPercentage } = tableData.menuOrder;
        setServiceChargePercentage(serviceChargePercentage || 0);
        setTaxPercentage(taxPercentage || 0);
      } else {
        setApiOrderedItems([]);
        setOrderId(null);
      }
    } catch (error) {
      console.error("Error fetching ordered items:", error);
      toast.error("Failed to fetch ordered items");
    } finally {
      setLoading(false);
    }
  };

  const handleTableSelect = (selected) => {
    setSelectedTable(selected);
    if (selected) {
      fetchOrderedItems();
    } else {
      setApiOrderedItems([]);
      setLocalOrderedItems([]);
      setOrderId(null);
    }
  };

  const updateLocalStorage = (updatedItems) => {
    let storedData = JSON.parse(localStorage.getItem("orders")) || [];
    const tableIndex = storedData.findIndex(
      (order) => order.tableID === selectedTable.id
    );

    const updatedTableOrder = {
      tableID: selectedTable.id,
      items: updatedItems,
      serviceChargePercentage,
      taxPercentage,
    };

    if (tableIndex !== -1) {
      storedData[tableIndex] = updatedTableOrder;
    } else {
      storedData.push(updatedTableOrder);
    }

    localStorage.setItem("orders", JSON.stringify(storedData));
    fetchOrderedItems();
  };

  const handleIncrement = (item, source) => {
    try {
      const updatedItems =
        source === "Local Storage"
          ? localOrderedItems.map((orderItem) =>
              orderItem.menuOrderDetailId === item.menuOrderDetailId
                ? {
                    ...orderItem,
                    quantity: orderItem.quantity + 1,
                    totalPrice: (orderItem.quantity + 1) * orderItem.price,
                  }
                : orderItem
            )
          : apiOrderedItems.map((orderItem) =>
              orderItem.menuOrderDetailId === item.menuOrderDetailId
                ? {
                    ...orderItem,
                    quantity: orderItem.quantity + 1,
                    totalPrice: (orderItem.quantity + 1) * orderItem.price,
                  }
                : orderItem
            );

      if (source === "Local Storage") {
        setLocalOrderedItems(updatedItems);
        updateLocalStorage(updatedItems);
      } else {
        setApiOrderedItems(updatedItems);
      }
      // toast.success("Order Updated Successfully");
    } catch (error) {
      console.error("Error updating item quantity:", error);
      toast.error("Failed to update item quantity");
    }
  };

  const handleDecrement = (item, source) => {
    if (item.quantity <= 1) return;

    try {
      const updatedItems =
        source === "Local Storage"
          ? localOrderedItems.map((orderItem) =>
              orderItem.menuOrderDetailId === item.menuOrderDetailId
                ? {
                    ...orderItem,
                    quantity: orderItem.quantity - 1,
                    totalPrice: (orderItem.quantity - 1) * orderItem.price,
                  }
                : orderItem
            )
          : apiOrderedItems.map((orderItem) =>
              orderItem.menuOrderDetailId === item.menuOrderDetailId
                ? {
                    ...orderItem,
                    quantity: orderItem.quantity - 1,
                    totalPrice: (orderItem.quantity - 1) * orderItem.price,
                  }
                : orderItem
            );

      if (source === "Local Storage") {
        setLocalOrderedItems(updatedItems);
        updateLocalStorage(updatedItems);
      } else {
        setApiOrderedItems(updatedItems);
      }
      // toast.success("Order Updated Successfully");
    } catch (error) {
      console.error("Error updating item quantity:", error);
      toast.error("Failed to update item quantity");
    }
  };

  const handleRemove = async (item, source) => {
    try {
      if (source === "Local Storage") {
        // Handle local storage items as before
        const updatedItems = localOrderedItems.filter(
          (orderItem) => orderItem.menuOrderDetailId !== item.menuOrderDetailId
        );
        setLocalOrderedItems(updatedItems);
        updateLocalStorage(updatedItems);
      } else {
        // For API items, call the delete API first
        setLoading(true);

        // Extract the numeric ID if it's stored as a string
        const menuOrderDetailId = isNaN(parseInt(item.menuOrderDetailId))
          ? item.menuOrderDetailId
          : parseInt(item.menuOrderDetailId);

        // Call the delete API
        await OrderManagementService.deleteOrderItem(
          orderId,
          menuOrderDetailId
        );

        // Then update the UI
        const updatedItems = apiOrderedItems.filter(
          (orderItem) => orderItem.menuOrderDetailId !== item.menuOrderDetailId
        );
        setApiOrderedItems(updatedItems);

        // Refresh the ordered items to ensure UI is in sync with server
        await fetchOrderedItems();
      }
      toast.success("Item removed successfully");
    } catch (error) {
      console.error("Error removing item:", error);
      toast.error(
        "Failed to remove item: " + (error.message || "Unknown error")
      );
    } finally {
      setLoading(false);
    }
  };

  const validateOrder = () => {
    if (!orgCode) {
      toast.error("Organization code not found. Please try logging in again.");
      return false;
    }
    if (localOrderedItems.length === 0 && apiOrderedItems.length === 0) {
      toast.error("Your order is empty.");
      return false;
    }
    if (!selectedTable) {
      toast.error("Please select a table");
      return false;
    }
    return true;
  };

  const handlePlaceOrder = async () => {
    if (!validateOrder()) return;

    setLoading(true);
    try {
      const combinedItems = [...apiOrderedItems, ...localOrderedItems];
      const orderPayload = {
        tableId: selectedTable.id,
        items: combinedItems.map((item) => ({
          menuItemId: item.menuItemId,
          quantity: item.quantity,
          price: item.price,
          totalPrice: item.totalPrice,
        })),
        serviceChargePercentage,
        taxPercentage,
        additionalDiscount: parseFloat(additionalDiscount) || 0,
      };

      const response = await OrderManagementService.addOrder(
        orgCode,
        orderPayload
      );
      setOrderId(response.id); // Store the order ID
      console.log("Order placed successfully:", response);

      let storedData = JSON.parse(localStorage.getItem("orders")) || [];
      storedData = storedData.filter(
        (order) => order.tableID !== selectedTable.id
      );
      localStorage.setItem("orders", JSON.stringify(storedData));

      toast.success("Order placed successfully!");
      await fetchOrderedItems();
      await fetchTables();
    } catch (error) {
      console.error("Error placing order:", error);
      toast.error(
        "Failed to place order: " + (error.message || "Unknown error")
      );
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateOrder = async () => {
    if (!orderId || !validateOrder()) return;

    setLoading(true);
    try {
      const combinedItems = [...apiOrderedItems, ...localOrderedItems];

      const updatedData = {
        items: combinedItems.map((item) => ({
          menuItemId: item.menuItemId,
          quantity: item.quantity,
          // For local items (string IDs), send 0 to indicate new items
          // For API items (numeric IDs), send the actual ID
          menuOrderDetailId: isNaN(parseInt(item.menuOrderDetailId))
            ? 0
            : parseInt(item.menuOrderDetailId),
        })),
      };

      const response = await OrderManagementService.update(
        orderId,
        updatedData
      );

      // Clear local storage for this table
      let storedData = JSON.parse(localStorage.getItem("orders")) || [];
      storedData = storedData.filter(
        (order) => order.tableID !== selectedTable.id
      );
      localStorage.setItem("orders", JSON.stringify(storedData));

      toast.success("Order updated successfully!");
      await fetchOrderedItems();
    } catch (error) {
      console.error("Error updating order:", error);
      toast.error(
        "Failed to update order: " + (error.message || "Unknown error")
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancelOrder = async () => {
    if (orderId) {
      setLoading(true);
      try {
        await OrderManagementService.cancelTable(orderId, 3);
        toast.success("Order cancelled successfully!");
        setOrderId(null);
        await fetchOrderedItems();
        await fetchTables();
      } catch (error) {
        console.error("Error cancelling order:", error);
        toast.error(
          "Failed to cancel order: " + (error.message || "Unknown error")
        );
      } finally {
        setLoading(false);
      }
    } else {
      // Clear local storage for the selected table
      let storedData = JSON.parse(localStorage.getItem("orders")) || [];
      storedData = storedData.filter(
        (order) => order.tableID !== selectedTable.id
      );
      localStorage.setItem("orders", JSON.stringify(storedData));
      setLocalOrderedItems([]);
      toast.success("Local order cleared successfully!");
    }
    setIsCancelModalOpen(false); // Close the modal after canceling
  };

  const handleDiscountChange = (e) => {
    const value = e.target.value;
    if (
      value === "" ||
      (/^\d*\.?\d*$/.test(value) && parseFloat(value) <= 100)
    ) {
      setAdditionalDiscount(value);
    }
  };

  const calculateTotalAmountBeforeDiscount = (items) =>
    items.reduce((total, item) => total + (item.price || 0) * item.quantity, 0);

  const calculateTotalDiscount = (items, subtotalAmount) => {
    const itemDiscounts = items.reduce((total, item) => {
      const originalPrice = item.price || 0;
      const discountPercentage = item.discountDetail?.discountPercentage || 0;
      return total + originalPrice * (discountPercentage / 100) * item.quantity;
    }, 0);

    const additionalDiscountAmount =
      additionalDiscount && !isNaN(parseFloat(additionalDiscount))
        ? subtotalAmount * (parseFloat(additionalDiscount) / 100)
        : 0;

    return itemDiscounts + additionalDiscountAmount;
  };

  const combinedItems = [...apiOrderedItems, ...localOrderedItems];
  const subtotalAmount = calculateTotalAmountBeforeDiscount(combinedItems);
  const totalDiscount = calculateTotalDiscount(combinedItems, subtotalAmount);
  const finalAmountBeforeTaxAndService = Math.max(
    0,
    subtotalAmount - totalDiscount
  );
  const serviceCharge =
    (finalAmountBeforeTaxAndService * serviceChargePercentage) / 100;
  const taxAmount = (finalAmountBeforeTaxAndService * taxPercentage) / 100;
  const netAmount = finalAmountBeforeTaxAndService + serviceCharge + taxAmount;

  const handlePaymentSubmit = async (paymentData) => {
    setPaymentLoading(true);
    try {
      const tableData = await TableService.getActiveTableList();
      const currentTable = tableData.find(
        (table) => table.id === selectedTable.id
      );
      if (!currentTable?.menuOrder?.id) {
        throw new Error("Order ID not found");
      }

      const paymentPayload = {
        addDiscount: parseFloat(additionalDiscount) || 0,
        type: parseInt(paymentData.type),
        name: paymentData.name.trim(),
        phoneNumber: paymentData.phoneNumber.trim(),
        address: paymentData.address.trim(),
        remarks: paymentData.remarks.trim(),
      };

      await OrderManagementService.processBillingPayment(
        currentTable.menuOrder.id,
        paymentPayload
      );

      // Store printBill data if the checkbox was checked
      if (paymentData.printBill) {
        setPrintBillData({
          name: paymentData.name.trim(),
          phoneNumber: paymentData.phoneNumber.trim(),
          address: paymentData.address.trim(),
          remarks: paymentData.remarks.trim(),
          paymentType: parseInt(paymentData.type),
        });
        setIsModalOpen(true); // Open the bill modal to print
      } else {
        setPrintBillData(null);
      }

      let storedData = JSON.parse(localStorage.getItem("orders")) || [];
      storedData = storedData.filter(
        (order) => order.tableID !== selectedTable.id
      );
      localStorage.setItem("orders", JSON.stringify(storedData));

      toast.success("Payment processed successfully!");
      setIsPaymentModalOpen(false);

      // Only reset if not printing
      if (!paymentData.printBill) {
        setSelectedTable(null);
        setAdditionalDiscount("");
        setApiOrderedItems([]);
        setLocalOrderedItems([]);
        setOrderId(null);
        await fetchTables();
      }
    } catch (error) {
      console.error("Error processing payment:", error);
      toast.error(error.message || "Failed to process payment");
    } finally {
      setPaymentLoading(false);
    }
  };

  const renderItems = (items, source) =>
    items.map((item) => {
      const originalPrice = item.price || 0;
      const discountPercentage = item.discountDetail?.discountPercentage || 0;
      const discountAmount = originalPrice * (discountPercentage / 100);
      const discountedPrice = originalPrice - discountAmount;

      return (
       

        // <div className="  card  col-9  col-sm-5 col-lg-3 p-3 position-relative ">
        //   <div
        //     className="d-flex row align-items-center justify-content-around justify-content-md-evenly "
        //     style={{ minHeight: "9rem", maxHeight: "fit-content" }}
        //   >
        //     {/* image */}
        //     <div className=" ">
        //       <img
        //         src={
        //           (typeof item.imageUrl === "string" && item.imageUrl) ||
        //           (item.cloudR2ImagePath &&
        //           typeof item.cloudR2ImagePath.getCDNUrl === "function"
        //             ? item.cloudR2ImagePath.getCDNUrl()
        //             : item.cloudR2ImagePath) ||
        //           "https://via.placeholder.com/150"
        //         }
        //         alt={item.title}
        //         className="rounded object-fit-cover"
        //         height={100}
        //         width={100}
        //       />
        //     </div>

        //     <div className="d-flex flex-column  justify-content-around">
        //       {/* content */}

        //       <div className=" m-0 p-0 d-flex  justify-content-between">
        //         <p className="fs-4  m-0 p-0">{item.title}</p>

        //         {/* <Button
        //             color="danger"
        //             className="btn-sm rounded-4 d-flex align-items-center justify-content-center position-absolute top-0 end-0"
        //             size="sm"
        //             onClick={() => handleRemove(item, source)}
        //           >
                   
        //               <i
        //                 className="ri-delete-bin-line"
                      
        //               ></i>
                    
        //           </Button> */}
        //       </div>

        //       {/* + -  */}
        //       <div className=" d-flex flex-column justify-content-center ">
            
        //           <div>
        //         <div className="d-flex  justify-content-between">

        //           <div>
        //             <div className="  text-start ">
        //               <p className=" fw-medium  fs-12 m-0 p-0">
        //                 Rs. {discountedPrice.toFixed(2)}
        //               </p>

        //               {discountPercentage > 0 && (
        //                 <p className="text-muted fs-10">
        //                   <del>Rs. {originalPrice.toFixed(2)}</del> (
        //                   {discountPercentage}% OFF)
        //                 </p>
        //               )}

        //               {/* <p className="text-muted fw-medium  fs-6  m-0 p-0" style={{fontSize: "2rem"}}>
        //               Total: Rs. {(discountedPrice * item.quantity).toFixed(2)}
        //           </p> */}
        //             </div>

        //             <p
        //               className=" fw-bold text-start fs-6  m-0 p-0"
        //               style={{ fontSize: "2rem" }}
        //             >
        //               Total: Rs. {(discountedPrice * item.quantity).toFixed(2)}
        //             </p>
        //           </div>

        //         <div>
        //           <Button
        //             color="danger"
        //             className="btn-sm rounded-4 d-flex align-items-center justify-content-center"
        //             size="sm"
        //             onClick={() => handleRemove(item, source)}
        //           >
        //             <i className="ri-delete-bin-line"></i>
        //           </Button>
        //           </div>

        //         </div>
        //         </div>

        //         {/* </div> */}

        //         <div className="btn-group quantity-controls">
        //           <Button
        //             size="sm"
        //             outline
        //             onClick={() => handleDecrement(item, source)}
        //           >
        //             -
        //           </Button>
        //           <Button size="sm" outline className="px-3 disabled">
        //             {item.quantity}
        //           </Button>
        //           <Button
        //             size="sm"
        //             outline
        //             onClick={() => handleIncrement(item, source)}
        //           >
        //             +
        //           </Button>
        //         </div>

        //       </div>
        //     </div>
        //   </div>
        // </div>

        <Col xs={11}  className=" card mb-2  position-relative ">
          <Row
            className="  align-items-center m-0 p-0  justify-content-center "
         
            style={{ minHeight: "6.5rem", maxHeight: "fit-content" }}
            // style={{height: "6.5rem"}}
          
          >
            {/* image */}
            <Col xs={4} sm={3}  className="  text-center">
              <img
                src={
                  (typeof item.imageUrl === "string" && item.imageUrl) ||
                  (item.cloudR2ImagePath &&
                  typeof item.cloudR2ImagePath.getCDNUrl === "function"
                    ? item.cloudR2ImagePath.getCDNUrl()
                    : item.cloudR2ImagePath) ||
                  "https://via.placeholder.com/150"
                }
                alt={item.title}
                // className="rounded object-fit-cover"
                // height={60}
                // width={70}
                className="h-75 w-75 object-fit-cover"
                // style={{objectFit: "cover"}}
              />
            </Col>

            <Col className="d-flex flex-column  justify-content-around">
              {/* content */}

              <div className=" m-0 p-0 d-flex  justify-content-between">
                <p className="fs-5  m-0 p-0" style={{lineHeight: "30px"}}>{item.title}</p>

              
              </div>

              {/* + -  */}
              <div className=" d-flex flex-column justify-content-center ">
            
                  <div>
                <div className="d-flex  justify-content-between">

                  <div>
                    <div className="  text-start ">
                      <p className=" fw-muted  fs-6 m-0 p-0">
                        Rs. {discountedPrice.toFixed(2)}
                      </p>

                      {discountPercentage > 0 && (
                        <p className="fw-bold fs-6">
                          <del>Rs. {originalPrice.toFixed(2)}</del> (
                          {discountPercentage}% OFF)
                        </p>
                      )}

                      {/* <p className="text-muted fw-medium  fs-6  m-0 p-0" style={{fontSize: "2rem"}}>
                      Total: Rs. {(discountedPrice * item.quantity).toFixed(2)}
                  </p> */}
                    </div>

                    <p
                      className=" fw-bold text-start fs-12  m-0 p-0"
                      style={{ fontSize: "2rem" }}
                    >
                      Total: Rs. {(discountedPrice * item.quantity).toFixed(2)}
                    </p>
                  </div>

                {/* <div className="position-absolute top-0 start-0">
                  <Button
                    color="danger"
                    className="btn-sm rounded-4 d-flex align-items-center justify-content-center "
                    size="sm"
                    onClick={() => handleRemove(item, source)}
                  >
                    <i className="ri-delete-bin-line small"></i>
                  </Button>
                
                </div> */}

                </div>
                </div>

                {/* </div> */}

                <div className="btn-group quantity-controls  w-50">
                  <Button
                    size="sm"
                    outline
                    onClick={() => handleDecrement(item, source)}
                  >
                    -
                  </Button>
                  <Button size="sm" outline className="px-3 disabled">
                    {item.quantity}
                  </Button>
                  <Button
                    size="sm"
                    outline
                    onClick={() => handleIncrement(item, source)}
                  >
                    +
                  </Button>
                  <Button
                    color="danger"
                    // className="btn-sm rounded-4 d-flex align-items-center justify-content-center "
                    outline
                    size="sm"
                    onClick={() => handleRemove(item, source)}
                  >
                    <i className="ri-delete-bin-line small"></i>
                  </Button>
                </div>

              </div>
            </Col>

          </Row>
      </Col>
      );
    });

  return (
    <Col
    

      //   style={{ display: "flex", flexDirection: "column", height: "100vh" }}
    >
      {/* <Row
        className="mb-2 g-2"
        style={{ position: "sticky", top: 0, zIndex: 1 }}
      >
        <Col lg={6} md={12} sm={12}>
          <input
            type="text"
            className="form-control"
            placeholder="Customer Contact"
            required
          />
        </Col>
        <Col lg={6} md={12} sm={12}>
          <Select
            options={tables}
            value={selectedTable}
            onChange={handleTableSelect}
            placeholder="Select Table"
            isClearable
            className="table-select z-index-1"
            styles={{
              option: (provided, state) => ({
                ...provided,
                color: state.data.isOccupied ? "red" : "black",
                cursor: "pointer",
              }),
              control: (provided) => ({
                ...provided,
                borderColor: selectedTable?.isOccupied
                  ? "red"
                  : provided.borderColor,
                boxShadow: "none",
                "&:hover": {
                  borderColor: selectedTable?.isOccupied
                    ? "red"
                    : provided.borderColor,
                },
              }),
            }}
          />
        </Col>
      </Row> */}

      {loading && (
        <div className="d-flex justify-content-center align-items-center">
          <Triangle
            visible={true}
            height="80"
            width="80"
            color="#5B71B9"
            ariaLabel="triangle-loading"
          />
        </div>
      )}

      {/* from here */}

      <Row className="  " >
        <Col xs={12}  className=" ">
          {!loading && (
            <Row
              className="ordered-items-section overflow-y-auto justify-content-center align-items-center   justify-content-lg-center align-items-lg-center"
              style={{ maxHeight: "16rem", backgroundColor: "#FBFDFE" }}
            >

        
              {/* <h6>Ordered Items</h6> */}
              {combinedItems.length > 0 ? (
                <>
                  {renderItems(apiOrderedItems, "API")}
                  {renderItems(localOrderedItems, "Local Storage")}
                </>
              ) : (
                <div className="text-center p-4 d-flex flex-column align-items-center justify-content-center">
                  <div className="d-flex justify-content-center align-items-center p-2 bg-white rounded-sm">
                    <i className="ri-restaurant-line fs-3"></i>
                  </div>
                  <p className=" mb-0">No ordered items for this table</p>
                </div>
              )}
            </Row>
          )}
        </Col>

        <Col xs={12}  className=" px-4">

        <div>
          {role !== "Waiter" && (loading) ? (<div>
            
                <span>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                Loading...
                </span>
             
          </div>) : (
            <div className="d-flex">
              <div
                // ref={contentRef}
                className=" shadow-sm  w-100 Paymentcard"
              >
                <div className="d-flex justify-content-between align-items-center  gap-2 ">
                  {!orderId ? (
                    <Button
                      color="primary"
                      className="btn-sm rounded-4 flex-grow-1"
                      style={{ height: "25px" }}
                      onClick={handlePlaceOrder}
                      disabled={loading || combinedItems.length === 0}
                    >
                      {loading ? (
                        <span>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Placing Order...
                        </span>
                      ) : (
                        "Place Order"
                      )}
                    </Button>
                  ) : (
                    <Button
                      color="primary"
                      className="btn-sm rounded-4 flex-grow-1"
                      style={{ height: "25px" }}
                      onClick={handleUpdateOrder}
                      disabled={loading || combinedItems.length === 0}
                    >
                      {loading ? (
                        <span>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Updating Order...
                        </span>
                      ) : (
                        "Update Order"
                      )}
                    </Button>
                  )}
                  <Button
                    color="danger"
                    className="btn-sm rounded-4 d-flex align-items-center justify-content-center"
                    style={{ height: "25px", width: "30px" }}
                    onClick={() => setIsCancelModalOpen(true)}
                    disabled={
                      loading || (localOrderedItems.length === 0 && !orderId)
                    }
                  >
                    {loading ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <i
                        className="ri-delete-bin-line"
                        style={{ fontSize: "16px" }}
                      ></i>
                    )}
                  </Button>
                </div>

                <div className="d-flex justify-content-between  ">
                  <p className="mb-0 fw-bold fs-6">Net Amount:</p>
                  <p className="mb-0 fw-bold text-success fs-6">
                    Rs. {netAmount.toFixed(2)}
                  </p>
                </div>

                <div className="d-flex  w-100 justify-content-evenly   gap-2">
                  <Button
                    className="w-100 btn-sm"
                    color="secondary"
                    onClick={() => setIsModalOpen(true)}
                    disabled={combinedItems.length === 0}
                  >
                    View Bill
                  </Button>
                  <Button
                    color="primary"
                    className="w-100 btn-sm "
                    onClick={() => setIsPaymentModalOpen(true)}
                    disabled={loading || combinedItems.length === 0}
                  >
                    {loading ? (
                      <span>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Pay Now"
                    )}
                  </Button>
                </div>
              </div>
            </div>
          )}
          </div>
        </Col>
      </Row>

      {/* to here */}

      <Modal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(!isModalOpen)}
        size="md"
      >
        <ModalHeader toggle={() => setIsModalOpen(!isModalOpen)} />
        <ModalBody>
          <BillContent
            currentOrder={combinedItems}
            totalAmountBeforeDiscount={subtotalAmount}
            totalDiscount={totalDiscount}
            serviceCharge={serviceCharge}
            taxAmount={taxAmount}
            netAmount={netAmount}
          />
        </ModalBody>
        <ModalFooter>
          <DownloadBill
            currentOrder={combinedItems}
            totalAmountBeforeDiscount={subtotalAmount}
            totalDiscount={totalDiscount}
            serviceCharge={serviceCharge}
            taxAmount={taxAmount}
            netAmount={netAmount}
          />
          <PrintBill
            currentOrder={combinedItems}
            totalAmountBeforeDiscount={subtotalAmount}
            totalDiscount={totalDiscount}
            serviceCharge={serviceCharge}
            taxAmount={taxAmount}
            netAmount={netAmount}
            customerData={printBillData}
          />
          <Button color="secondary" onClick={() => setIsModalOpen(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      <PaymentModal
        isOpen={isPaymentModalOpen}
        toggle={() => setIsPaymentModalOpen(!isPaymentModalOpen)}
        onSubmit={handlePaymentSubmit}
        loading={paymentLoading}
      />
      <CancelOrderModal // Include the cancel modal component
        isOpen={isCancelModalOpen}
        toggle={() => setIsCancelModalOpen(!isCancelModalOpen)}
        onConfirm={handleCancelOrder}
      />
    </Col>
  );
};

// {!loading && (
//   <div className="ordered-items-section overflow-y-auto px-2 px-md-5 " style={{maxHeight: "20rem",}}  >
//     {/* <h6>Ordered Items</h6> */}
//     {combinedItems.length > 0 ? (
//       <>
//         {renderItems(apiOrderedItems, "API")}
//         {renderItems(localOrderedItems, "Local Storage")}
//       </>
//     ) : (
//       <div className="text-center p-4 d-flex flex-column align-items-center justify-content-center">
//         <div className="d-flex justify-content-center align-items-center p-2 bg-white rounded-sm">
//           <i className="ri-restaurant-line fs-3"></i>
//         </div>
//         <p className=" mb-0">No ordered items for this table</p>
//       </div>
//     )}
//   </div>
// )}

// {role !== "Waiter" &&
// (<div className="d-flex justify-content-center align-content-center">
//   <div ref={contentRef} className="card shadow-sm p-3 Paymentcard" >

//     <div className="d-flex justify-content-between align-items-center mb-2 gap-2">
//       {!orderId ? (
//         <Button
//           color="primary"
//           className="btn-sm rounded-4 flex-grow-1"
//           style={{ height: "30px" }}
//           onClick={handlePlaceOrder}
//           disabled={loading || combinedItems.length === 0}
//         >
//           {loading ? (
//             <span>
//               <span
//                 className="spinner-border spinner-border-sm me-2"
//                 role="status"
//                 aria-hidden="true"
//               ></span>
//               Placing Order...
//             </span>
//           ) : (
//             "Place Order"
//           )}
//         </Button>
//       ) : (
//         <Button
//           color="primary"
//           className="btn-sm rounded-4 flex-grow-1"
//           style={{ height: "30px" }}
//           onClick={handleUpdateOrder}
//           disabled={loading || combinedItems.length === 0}
//         >
//           {loading ? (
//             <span>
//               <span
//                 className="spinner-border spinner-border-sm me-2"
//                 role="status"
//                 aria-hidden="true"
//               ></span>
//               Updating Order...
//             </span>
//           ) : (
//             "Update Order"
//           )}
//         </Button>
//       )}
//       <Button
//         color="danger"
//         className="btn-sm rounded-4 d-flex align-items-center justify-content-center"
//         style={{ height: "30px", width: "30px" }}
//         onClick={() => setIsCancelModalOpen(true)}
//         disabled={loading || (localOrderedItems.length === 0 && !orderId)}
//       >
//         {loading ? (
//           <span
//             className="spinner-border spinner-border-sm"
//             role="status"
//             aria-hidden="true"
//           ></span>
//         ) : (
//           <i
//             className="ri-delete-bin-line"
//             style={{ fontSize: "16px" }}
//           ></i>
//         )}
//       </Button>
//     </div>

//     <div className="d-flex justify-content-between mb-2">
//       <p className="mb-0 fw-bold">Net Amount:</p>
//       <p className="mb-0 fw-bold text-success">
//         Rs. {netAmount.toFixed(2)}
//       </p>
//     </div>

//     <div className="d-flex justify-content-between gap-2">
//       <Button
//         className="w-100 btn-sm"
//         color="secondary"
//         onClick={() => setIsModalOpen(true)}
//         disabled={combinedItems.length === 0}
//       >
//         View Bill
//       </Button>
//       <Button
//         color="primary"
//         className="w-100 btn-sm"
//         onClick={() => setIsPaymentModalOpen(true)}
//         disabled={loading || combinedItems.length === 0}
//       >
//         {loading ? (
//           <span>
//             <span
//               className="spinner-border spinner-border-sm me-2"
//               role="status"
//               aria-hidden="true"
//             ></span>
//             Processing...
//           </span>
//         ) : (
//           "Pay Now"
//         )}
//       </Button>
//     </div>

//   </div>
//   </div>)}
